import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import IsDomainAvailableResponseDto = Cloud.RavenDB.Core.Dto.Domains.IsDomainAvailableResponseDto;
import IsDomainAvailableRequestDto = Cloud.RavenDB.Core.Dto.Domains.IsDomainAvailableRequestDto;
import IsSubdomainAvailableRequestDto = Cloud.RavenDB.Core.Dto.Domains.IsSubdomainAvailableRequestDto;
import IsSubdomainAvailableResponseDto = Cloud.RavenDB.Core.Dto.Domains.IsSubdomainAvailableResponseDto;
import ProductTier = Cloud.RavenDB.Core.Models.ProductTier;

export class DomainService extends AbstractService {
    checkDomainAvailability = async (domain: string): Promise<boolean> => {
        const response = await this.post<IsDomainAvailableRequestDto, IsDomainAvailableResponseDto>(
            ApiRoutes.domain.isAvailable(),
            { name: domain }
        );
        return response.data.available;
    };

    checkSubdomainAvailability = async (tier: ProductTier, domainName: string, subdomainName: string) => {
        const response = await this.post<IsSubdomainAvailableRequestDto, IsSubdomainAvailableResponseDto>(
            ApiRoutes.domain.isSubdomainAvailable(),
            {
                tier,
                domainName,
                subdomainName,
            }
        );

        return response.data.available;
    };
}
